



















































































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
// CAMBIO: Se importa el validador `decimal` en lugar de `numeric`.
import { required, decimal } from "vuelidate/lib/validators";
import { Local } from "@/typings/store/plugins/easyFirestore/locales";
import { CentroCosto } from "@/typings/store/plugins/easyFirestore/centrosCostos";
import { DataFormularioLocal } from "@/typings/components/locales/formulario";

@Component({
  validations: {
    form: {
      centroCosto: { required },
      unidadLocativa: { required },
      // CAMBIO: Se usa la validación `decimal`.
      superficie: { required, decimal },
      nivel: { required },
      fachada: { required },
      vista_planta: { required },
      estadoLocal: { required },
      tipo_local: { required },
    },
  },
})
export default class FormularioLocal extends Vue {
  @Prop() readonly local!: Local | null;
  @Prop() readonly cargando!: boolean;
  @Prop({ default: 0 }) readonly codigoLocal!: number;
  @Prop({ default: () => [] }) readonly centrosCostos!: CentroCosto[];

  form: Partial<Local> = {};

  opciones = {
    tipo_local: [
      "CASA",
      "DEPARTAMENTO",
      "ESPACIO",
      "ESTACIONAMIENTO",
      "LOCAL",
      "MODULO",
      "SUPERMERCADO",
      "OFICINA",
    ],
    estadoLocal: ["DISPONIBLE", "OCUPADO", "RESERVADO", "EN MANTENCION"],
  };

  created(): void {
    this.resetForm();
    if (this.local) {
      this.form = { ...this.local };
    }
  }

  resetForm(): void {
    this.form = {
      codigo: "",
      centroCosto: "",
      unidadLocativa: "",
      superficie: 0,
      nivel: "",
      fachada: "",
      vista_planta: "",
      estadoLocal: "DISPONIBLE",
      tipo_local: "LOCAL",
    };
    this.$v.$reset();
  }

  get titulo(): string {
    return this.local ? "Editar Local" : "Ingresar Nuevo Local";
  }

  getErrors(fieldName: string): string[] {
    const errors: string[] = [];
    const field = this.$v.form?.[fieldName];
    if (!field || !field.$dirty) return errors;

    if (field.required === false) {
      errors.push("Este campo es obligatorio.");
    }
    // CAMBIO: Se añade un mensaje de error para la validación `decimal`.
    if (field.decimal === false) {
      errors.push("Debe ser un número válido (ej: 120.5).");
    }
    return errors;
  }

  @Emit("close")
  onClose(): void {
    this.resetForm();
  }

  @Emit("click-guardar")
  onClickGuardar(data: DataFormularioLocal): DataFormularioLocal {
    return data;
  }

  guardar(): void {
    this.$v.form.$touch();
    if (this.$v.form.$invalid) {
      return;
    }

    const data: DataFormularioLocal = {
      doc: this.form as Local,
    };
    this.onClickGuardar(data);
  }
}
